<script setup lang="ts">
defineProps<{
  icon: string;
}>();
</script>

<template>
  <div class="LockedIcon">
    <v-icon>{{ icon }}</v-icon>
    <v-icon class="LockedIcon_lock">mdi-lock-outline</v-icon>
  </div>
</template>

<style scoped lang="scss">
.LockedIcon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 21px;
  height: 21px;
  position: relative;
}

.LockedIcon_lock {
  position: absolute;
  right: -4px;
  top: 4px;
  width: 4px;
  height: 4px;
  scale: 0.7;

  &::before {
    // background-color: rgb(var(--v-theme-background));
  }
}
</style>
